import styles from "./Select.module.scss"
import cx from "classnames"

const SelectField = ({
  field,
  methods,
  error = false,
  className,
  inputClassName,
}) => {
  const { label, placeholder, name, options } = field
  const { register } = methods

  return (
    <div className={cx(styles.inputWrapper, className)}>
      <label className={styles.label}>{label}</label>
      <select
        defaultValue=""
        className={cx(styles.input, { [styles.error]: error }, inputClassName)}
        {...register(name)}
      >
        <option value="" disabled>
          {placeholder || "Bitte wählen"}
        </option>

        {options &&
          options.map((option, i) => (
            <option key={i + 1} value={option.value}>
              {option.label}
            </option>
          ))}
      </select>
    </div>
  )
}

export default SelectField
